/* eslint-disable react/forbid-prop-types */
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {
  extend,
  QueryProvider,
  QueryContext
} from '@thd-nucleus/data-sources';
import { useStore, ExperienceContext } from '@thd-nucleus/experience-context';
import {
  SpecialBuyPromosProductPod
} from './subcomponents/special-buy-product-pod/SpecialBuyPromosProductPod';
import { ProductPlaceholder } from './subcomponents/product-placeholder/ProductPlaceholder';

const SpecialBuyPromosProductPodHoistingWrapper = ({ children }) => <>{children}</>;
SpecialBuyPromosProductPodHoistingWrapper.propTypes = { children: PropTypes.node.isRequired };
SpecialBuyPromosProductPodHoistingWrapper.dataModel = extend(SpecialBuyPromosProductPod);

export const ProductsGrid = ({
  id,
  products
}) => {
  const { channel } = useContext(ExperienceContext);
  const isMobile = channel === 'mobile';
  const store = useStore();
  const { storeId, storeZip } = store;
  const { isClientResolved, defaultVariables } = useContext(QueryContext);

  const skipFn = ({ skip, queryName, attributes }) => {
    if (queryName !== 'product') return skip;
    const isResolved = isClientResolved({ queryName: 'specialBuyItems' });
    return (attributes?.product?.fulfillment && !isResolved) || skip;
  };

  const promoVariables = {
    storeId,
    dataSource: 'searchNav',
    zipCode: storeZip,
    skipInstallServices: true,
    loyaltyMembershipInput: null
  };

  // for map policy compliance
  if (typeof defaultVariables?.current?.isBrandPricingPolicyCompliant === 'boolean') {
    promoVariables.isBrandPricingPolicyCompliant = defaultVariables?.current?.isBrandPricingPolicyCompliant;
  }

  const productsCss = classNames('sui-gap-2 lg:sui-p-2 md:sui-p-2 sm:sui-p-0', {
    'sui-h-full': isMobile
  });

  return (
    <QueryProvider
      dataSource="searchNav"
      cacheKey={`special-buy-products-${id}`}
      defaultVariables={promoVariables}
      skip={skipFn}
    >
      <SpecialBuyPromosProductPodHoistingWrapper>
        <div className="sui-w-full sui-grid sui-grid-cols-1 xl:sui-grid-cols-4 lg:sui-grid-cols-3
         sm:sui-grid-cols-2 sui-gap-1"
        >
          {products.map((product, index) => {
            const { itemId, showPlaceholder } = product;
            return (
              <div className={productsCss} key={itemId}>
                {showPlaceholder ? (
                  <ProductPlaceholder />
                ) : (
                  <SpecialBuyPromosProductPod
                    itemId={itemId}
                    showPlaceholder={!!showPlaceholder}
                    position={index}
                  />
                )}
              </div>
            );
          })}
        </div>
      </SpecialBuyPromosProductPodHoistingWrapper>
    </QueryProvider>
  );
};

ProductsGrid.displayName = 'ProductsGrid';

ProductsGrid.dataModel = extend({}, SpecialBuyPromosProductPodHoistingWrapper);

ProductsGrid.propTypes = {
  id: PropTypes.string.isRequired,
  products: PropTypes.arrayOf(PropTypes.any).isRequired
};
